const state = [
    {
        language: "Arabic",
        code: "ar-XA",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Amani",
                        code: "ar-XA-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Karyme",
                        code: "ar-XA-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Lupe",
                        code: "ar-XA-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Zeina",
                        code: "Zeina",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Achmed",
                        code: "ar-XA-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Hussein",
                        code: "ar-XA-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Jafar",
                        code: "ar-XA-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Karim",
                        code: "ar-XA-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Bulgarian (Bulgaria)', code: 'bg-BG',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Daria",
                        code: "bg-BG-Standard-A",
                        vendor: "Nuance",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/bg_bg_s1_Daria.wav')
                    },
                    {
                        name: "Kalina",
                        code: "bg-BG-KalinaNeural",
                        vendor: "Azure",
                        voiceType: "Neural",
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Ivan",
                        code: "bg-BG-Ivan",
                        vendor: "Azure",
                        voiceType: "Standard",
                    },
                    {
                        name: "Borislav",
                        code: "bg-BG-BorislavNeural",
                        vendor: "Azure",
                        voiceType: "Neural",
                    }
                ]
            }
        ]
    },
    {
        language: 'Danish (Denmark)', code: 'da-DK',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Grete",
                        code: "da-DK-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/da_dk_s1_Grete.mp3')
                    },
                    {
                        name: "Ingrid",
                        code: "da-DK-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: require('../../assets/audio/gallery/da_dk_s3_Ingrid.mp3')
                    },
                    {
                        name: "Ella",
                        code: "da-DK-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Sofia",
                        code: "da-DK-Wavenet-E",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Greta",
                        code: "da-DK-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Alma",
                        code: "da-DK-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Naja",
                        code: "Naja",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Noah",
                        code: "da-DK-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Oscar",
                        code: "da-DK-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Mads",
                        code: "Mads",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: "Greek (Greece)",
        code: "el-GR",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Elena",
                        code: "el-GR-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Sophia",
                        code: "el-GR-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: "male",
                characters: []
            }
        ]
    },
    {
        language: 'Dutch (Netherlands)', code: 'nl-NL',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Jasmijn",
                        code: "nl-NL-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/nl_nl_s1_Jasmijn.mp3')
                    },
                    {
                        name: "Katja",
                        code: "nl-NL-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: require('../../assets/audio/gallery/nl_nl_s3_Lotte.mp3')
                    },
                    {
                        name: "Zoe",
                        code: "nl-NL-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Eva",
                        code: "nl-NL-Wavenet-E",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Tess",
                        code: "nl-NL-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Fenna",
                        code: "nl-NL-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Lotte",
                        code: "Lotte",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Daan",
                        code: "nl-NL-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Bram",
                        code: "nl-NL-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Jesse",
                        code: "nl-NL-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Topias",
                        code: "nl-NL-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Ruben",
                        code: "Ruben",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'English (Australia)', code: 'en-AU',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Daisy",
                        code: "en-AU-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_au_s1_Daisy.mp3')

                    },
                    {
                        name: "Fiona",
                        code: "en-AU-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_au_s2_Fiona.mp3')

                    },
                    {
                        name: "Kiara",
                        code: "en-AU-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_au_s3_Kiara.mp3')

                    },
                    {
                        name: "Madeline",
                        code: "en-AU-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_au_s4_Madeline.mp3')
                    },
                    {
                        name: "Nicole",
                        code: "Nicole",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Olivia",
                        code: "Olivia",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Daymion",
                        code: "en-AU-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_au_s1_Daymion.mp3')

                    },
                    {
                        name: "Ethan",
                        code: "en-AU-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_au_s2_Ethan.mp3')

                    },
                    {
                        name: "Harper",
                        code: "en-AU-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_au_s3_Harper.mp3')

                    },
                    {
                        name: "Mason",
                        code: "en-AU-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_au_s4_Mason.mp3')

                    },
                    {
                        name: "Russell",
                        code: "Russell",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"

                    }
                ]
            }
        ]
    },
    {
        language: 'English (UK)', code: 'en-GB',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Alice",
                        code: "en-GB-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s1_Alice.mp3')
                    },
                    {
                        name: "Ella",
                        code: "en-GB-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s2_Ella.mp3')

                    },
                    {
                        name: "Hailey",
                        code: "en-GB-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s3_Hailey.mp3')

                    },
                    {
                        name: "Maddy",
                        code: "en-GB-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s4_Maddy.mp3')

                    },
                    {
                        name: "Lara",
                        code: "en-GB-Wavenet-F",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },

                    {
                        name: "Olivia",
                        code: "en-GB-Standard-F",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Amy",
                        code: "Amy",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    },
                    {
                        name: "Ema",
                        code: "Ema",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    },
                    {
                        name: "Amy",
                        code: "Amy",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Ema",
                        code: "Ema",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Alen",
                        code: "en-GB-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s1_Alen.mp3')

                    },
                    {
                        name: "Keeton",
                        code: "en-GB-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s2_Keeton.mp3')

                    },
                    {
                        name: "Oliver",
                        code: "en-GB-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s3_Oliver.mp3')

                    },
                    {
                        name: "Parker",
                        code: "en-GB-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_gb_s4_Parker.mp3')
                    }
                    ,
                    {
                        name: "Brian",
                        code: "Brian",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    }
                    ,
                    {
                        name: "Brian",
                        code: "Brian",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Indian English",
        code: "en-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Wishi",
                        code: "en-IN-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Aarna",
                        code: "en-IN-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Anushka",
                        code: "en-IN-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Daya",
                        code: "en-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Aditi",
                        code: "Aditi",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Raveena",
                        code: "Raveena",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Rishi",
                        code: "en-IN-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Prem",
                        code: "en-IN-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Pranav",
                        code: "en-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Mayank",
                        code: "en-IN-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Hindi (India)",
        code: "hi-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Veer",
                        code: "hi-IN-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Nadia",
                        code: "hi-IN-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Bhama",
                        code: "hi-IN-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Chavi",
                        code: "hi-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Aditi",
                        code: "Aditi",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Samaksh",
                        code: "hi-IN-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Samar",
                        code: "hi-IN-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Taimur",
                        code: "hi-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Veer",
                        code: "hi-IN-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Indonesian (Indonesia)",
        code: "id-ID",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Surya",
                        code: "id-ID-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Setia",
                        code: "id-ID-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Iman",
                        code: "id-ID-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Dian",
                        code: "id-ID-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Fajar",
                        code: "id-ID-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Wira",
                        code: "id-ID-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Yuda",
                        code: "id-ID-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Budi",
                        code: "id-ID-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Mandarin Chinese",
        code: "cmn-CN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Chenguang",
                        code: "cmn-CN-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Dongmei",
                        code: "cmn-CN-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Howin",
                        code: "cmn-CN-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Jing",
                        code: "cmn-CN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Zhiyu",
                        code: "Zhiyu",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Zhang Wei",
                        code: "cmn-CN-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Li Xiu Ying",
                        code: "cmn-CN-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Li Wei",
                        code: "cmn-CN-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Chang",
                        code: "cmn-CN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Mandarin Chinese",
        code: "cmn-TW",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Qi",
                        code: "cmn-TW-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Ru",
                        code: "cmn-TW-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Cheng",
                        code: "cmn-TW-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Chao",
                        code: "cmn-TW-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Shen",
                        code: "cmn-TW-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Jing",
                        code: "cmn-TW-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Czech (Czech Republic)",
        code: "cs-CZ",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Ana",
                        code: "cs-CZ-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Irena",
                        code: "cs-CZ-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: []
            }
        ]
    },
    {
        language: "Icelandic", code: 'is-IS',
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Dora",
                        code: "Dora",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Karl",
                        code: "Karl",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                ]
            }
        ]
    },
    {
        language: 'English (US)', code: 'en-US',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Beckie",
                        code: "en-US-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_us_s1_Beckie.mp3')

                    },
                    {
                        name: "Jodie",
                        code: "en-US-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_us_s2_Jodie.mp3')

                    },
                    {
                        name: "Karen",
                        code: "en-US-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s3_Karen.mp3')

                    },
                    {
                        name: "Pamela",
                        code: "en-US-Wavenet-E",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s4_Pamela.mp3')

                    },
                    {
                        name: "Susan",
                        code: "en-US-Wavenet-F",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s5_Susan.mp3')
                    },
                    {
                        name: "Elizabeth",
                        code: "en-US-Wavenet-G",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Lily",
                        code: "en-US-Wavenet-H",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Amy",
                        code: "en-US-Standard-G",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Helen",
                        code: "en-US-Standard-H",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Ivy (child)",
                        code: "Ivy",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    },
                    {
                        name: "Joanna",
                        code: "Joanna",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    },
                    {
                        name: "Kendra",
                        code: "Kendra",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    },
                    {
                        name: "Kimberly",
                        code: "Kimberly",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    },
                    {
                        name: "Salli",
                        code: "Salli",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    },
                    {
                        name: "Ivy (child)",
                        code: "Ivy",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Joanna",
                        code: "Joanna",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Kendra",
                        code: "Kendra",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Kimberly",
                        code: "Kimberly",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Salli",
                        code: "Salli",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Anthony",
                        code: "en-US-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_us_s1_Anthony.mp3')

                    },
                    {
                        name: "Earl",
                        code: "en-US-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/en_us_s2_Earl.mp3')

                    },
                    {
                        name: "Jason",
                        code: "en-US-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s3_Jason.mp3')

                    },
                    {
                        name: "Robin",
                        code: "en-US-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s4_Robin.mp3')

                    },
                    {
                        name: "Wesley",
                        code: "en-US-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/en_us_s5_Wesley.mp3')
                    },
                    {
                        name: "Tom",
                        code: "en-US-Wavenet-I",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Mark",
                        code: "en-US-Wavenet-J",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Jack",
                        code: "en-US-Standard-I",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Steve",
                        code: "en-US-Standard-J",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Joey",
                        code: "Joey",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Matthew",
                        code: "Matthew",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Kevin (child)",
                        code: "Kevin",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Justin (child)",
                        code: "Justin",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Joey",
                        code: "Joey",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Matthew",
                        code: "Matthew",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Kevin (child)",
                        code: "Kevin",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                    ,
                    {
                        name: "Justin (child)",
                        code: "Justin",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: 'French (Canada)', code: 'fr-CA',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Allese",
                        code: "fr-CA-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s1_Allese.mp3')
                    },
                    {
                        name: "Chloe",
                        code: "fr-CA-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s2_Chloe.mp3')
                    },
                    {
                        name: "Louise",
                        code: "fr-CA-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s3_Louise.mp3')
                    },
                    {
                        name: "Symone",
                        code: "fr-CA-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s4_Symone.mp3')
                    }
                    ,
                    {
                        name: "Chantal",
                        code: "Chantal",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Emanuel",
                        code: "fr-CA-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s1_Emanuel.mp3')
                    },
                    {
                        name: "Fabien",
                        code: "fr-CA-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s2_Fabien.mp3')
                    },
                    {
                        name: "Raphael",
                        code: "fr-CA-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s3_Raphael.mp3')
                    },
                    {
                        name: "Thierry",
                        code: "fr-CA-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_ca_s4_Thierry.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: 'French (France)', code: 'fr-FR',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Amelie",
                        code: "fr-FR-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s1_Amelie.mp3')
                    },
                    {
                        name: "Dennise",
                        code: "fr-FR-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s2_Dennise.mp3')
                    },
                    {
                        name: "Lisette",
                        code: "fr-FR-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s3_Lisette.mp3')
                    },
                    {
                        name: "Sophie",
                        code: "fr-FR-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s4_Sophie.mp3')
                    },
                    {
                        name: "Bette",
                        code: "fr-FR-Wavenet-E",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Danielle",
                        code: "fr-FR-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Celine",
                        code: "Celine",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Lea",
                        code: "Lea",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Jerome",
                        code: "fr-FR-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s1_Jerome.mp3')
                    },
                    {
                        name: "Maurice",
                        code: "fr-FR-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s2_Maurice.mp3')
                    },
                    {
                        name: "Sinclaire",
                        code: "fr-FR-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s3_Sinclaire.mp3')
                    },
                    {
                        name: "Travis",
                        code: "fr-FR-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/fr_fr_s4_Travis.mp3')
                    },
                    {
                        name: "Mathieu",
                        code: "Mathieu",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Hungarian (Hungary)",
        code: "hu-HU",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Lili",
                        code: "hu-HU-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                        "type": "FEMALE"
                    },
                    {
                        name: "Jazsmin",
                        code: "hu-HU-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                        "type": "FEMALE"
                    }
                ]
            }
        ]
    },
    {
        language: 'German (Germany)', code: 'de-DE',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Adelie",
                        code: "de-DE-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/de_de_s1_Adelie.mp3')
                    },
                    {
                        name: "Hannah",
                        code: "de-DE-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/de_de_s2_Hannah.mp3')
                    },
                    {
                        name: "Liezel",
                        code: "de-DE-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/de_de_s3_Liezel.mp3')
                    },
                    {
                        name: "Claudia",
                        code: "de-DE-Wavenet-F",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Gretel",
                        code: "de-DE-Standard-F",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Marlene",
                        code: "Marlene",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Vicki",
                        code: "Vicki",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Dietmar",
                        code: "de-DE-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/de_de_s1_Dietmar.mp3')

                    },
                    {
                        name: "Knut",
                        code: "de-DE-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/de_de_s2_Knut.mp3')
                    },
                    {
                        name: "Henzel",
                        code: "de-DE-Wavenet-E",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Werner",
                        code: "de-DE-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Siegfrid",
                        code: "de-DE-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/de_de_s3_Siegfrid.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: 'English (Welsh)', code: 'en-GB-WLS',
        voices: [{
            type: 'male',
            characters: [
                {

                    name: "Geraint",
                    code: "Geraint",
                    vendor: "aws",
                    voiceType: "Standard",
                    voiceSample: "todo"
                }
            ]
        }]
    },
    {
        language: 'Italian (Italy)', code: 'it-IT',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Giulia",
                        code: "it-IT-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/it_it_s1_Giulia.mp3')
                    },
                    {
                        name: "Francesca",
                        code: "it-IT-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/it_it_s3_Francesca.mp3')
                    },
                    {
                        name: "Marzia",
                        code: "it-IT-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Felicia",
                        code: "it-IT-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Carla",
                        code: "Carla",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Bianca",
                        code: "Bianca",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },

            {
                type: "male",
                characters: [
                    {
                        name: "Giovanni",
                        code: "it-IT-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Angelo",
                        code: "it-IT-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Michele",
                        code: "it-IT-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Massimo",
                        code: "it-IT-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Giorgio",
                        code: "Giorgio",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: 'Japanese (Japan)', code: 'ja-JP',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Akira",
                        code: "ja-JP-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ja_jp_s1_Akira.mp3')

                    },
                    {
                        name: "Fumiko",
                        code: "ja-JP-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ja_jp_s2_Fumiko.mp3')
                    },
                    {
                        name: "Toshiko",
                        code: "ja-JP-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Hono",
                        code: "ja-JP-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Mizuki",
                        code: "Mizuki",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Akio",
                        code: "ja-JP-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Yusaku",
                        code: "ja-JP-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Furukawa",
                        code: "ja-JP-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Morihei",
                        code: "ja-JP-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Takumi",
                        code: "Takumi",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: 'Korean (South Korea)', code: 'ko-KR',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Chin-Sun",
                        code: "ko-KR-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s1_ChinSun.mp3')
                    },
                    {
                        name: "Ho-Sook",
                        code: "ko-KR-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s2_HoSook.mp3')
                    },
                    {
                        name: "Kyung Mi",
                        code: "ko-KR-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s3_KyungMi.mp3')
                    },
                    {
                        name: "Min Jung",
                        code: "ko-KR-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s4_MinJung.mp3')
                    },
                    {
                        name: "Seoyeon",
                        code: "Seoyeon",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Dong-Min",
                        code: "ko-KR-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s1_DongMin.mp3')

                    },
                    {
                        name: "Ha Joon",
                        code: "ko-KR-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s2_HaJoon.mp3')
                    },
                    {
                        name: "Sang-Ook",
                        code: "ko-KR-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s3_SangOok.mp3')
                    },
                    {
                        name: "Yoo Joon",
                        code: "ko-KR-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ko_kr_s4_YooJoon.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: 'Norwegian (Norway)', code: 'nb-NO',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Annemari",
                        code: "nb-NO-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/nb_no_s1_Annemari.mp3')
                    },
                    {
                        name: "Kaari",
                        code: "nb-NO-Wavenet-E",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/nb_no_s3_Kaari.mp3')
                    },
                    {
                        name: "Kristin",
                        code: "nb-NO-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Olga",
                        code: "nb-NO-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Sigrun",
                        code: "nb-NO-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Liv",
                        code: "Liv",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Svein",
                        code: "nb-NO-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Christian",
                        code: "nb-NO-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Fredrik",
                        code: "nb-NO-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Johan",
                        code: "nb-NO-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Polish (Poland)', code: 'pl-PL',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Bozena",
                        code: "pl-PL-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s1_Bozena.mp3')
                    },
                    {
                        name: "Elzbieta",
                        code: "pl-PL-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s2_Elzbieta.mp3')
                    },
                    {
                        name: "Halinka",
                        code: "pl-PL-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s3_Halinka.mp3')
                    },
                    {
                        name: "Lidia",
                        code: "pl-PL-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s4_Lidia.mp3')
                    },
                    {
                        name: "Natasza",
                        code: "pl-PL-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s5_Natasza.mp3')
                    },
                    {
                        name: "Zuzanna",
                        code: "pl-PL-Wavenet-E",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s6_Zuzanna.mp3')
                    },
                    {
                        name: "Ewa",
                        code: "Ewa",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Maja",
                        code: "Maja",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Antek",
                        code: "pl-PL-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s1_Antek.mp3')
                    },
                    {
                        name: "Bolek",
                        code: "pl-PL-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s2_Bolek.mp3')
                    },
                    {
                        name: "Szymon",
                        code: "pl-PL-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s3_Szymon.mp3')
                    },
                    {
                        name: "Wojciech",
                        code: "pl-PL-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pl_pl_s4_Wojciech.mp3')
                    },
                    {
                        name: "Jacek",
                        code: "Jacek",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Jan",
                        code: "Jan",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Portuguese (Brazil)', code: 'pt-BR',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Francisca",
                        code: "pt-BR-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pt_br_s1_Francisca.mp3')
                    },
                    {
                        name: "Marcia",
                        code: "pt-BR-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pt_br_s2_Marcia.mp3')

                    },
                    {
                        name: "Camila",
                        code: "Camila",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    },
                    {
                        name: "Camila",
                        code: "Camila",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Vitoria",
                        code: "Vitoria",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
            ,
            {
                type: "male",
                characters: [
                    {
                        name: "Ricardo",
                        code: "Ricardo",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Portuguese (Portugal)', code: 'pt-PT',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Beatriz",
                        code: "pt-PT-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s1_Beatriz.mp3')
                    },
                    {
                        name: "Cesaria",
                        code: "pt-PT-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s2_Cesaria.mp3')
                    },
                    {
                        name: "Leonor",
                        code: "pt-PT-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s3_Leonor.mp3')

                    },
                    {
                        name: "Miciela",
                        code: "pt-PT-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s4_Miciela.mp3')
                    },
                    {
                        name: "Ines",
                        code: "Ines",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Alfonso",
                        code: "pt-PT-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s1_Alfonso.mp3')

                    },
                    {
                        name: "Filipe",
                        code: "pt-PT-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s2_Filipe.mp3')
                    },
                    {
                        name: "Miguel",
                        code: "pt-PT-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s3_Miguel.mp3')
                    },
                    {
                        name: "Rodrigo",
                        code: "pt-PT-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/pt_pt_s4_Rodrigo.mp3')
                    },
                    {
                        name: "Cristiano",
                        code: "Cristiano",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Finnish (Finland)",
        code: "fi-FI",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Hale",
                        code: "fi-FI-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Cecilia",
                        code: "fi-FI-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: "Filipino (Philippines)",
        code: "fil-PH",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Jasmina",
                        code: "fil-PH-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Mahalia",
                        code: "fil-PH-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Tala",
                        code: "fil-PH-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Reyna",
                        code: "fil-PH-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Datu",
                        code: "fil-PH-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Joriz",
                        code: "fil-PH-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo",
                    },
                    {
                        name: "Ramil",
                        code: "fil-PH-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    },
                    {
                        name: "Sinag",
                        code: "fil-PH-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: 'Romanian',
        code: 'ro-RO',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Carmen",
                        code: "Carmen",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo",
                    }
                ]
            }
        ]
    },
    {
        language: 'Russian (Russia)', code: 'ru-RU',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Anya",
                        code: "ru-RU-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s1_Anya.mp3')
                    },
                    {
                        name: "Katja",
                        code: "ru-RU-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s2_Katja.mp3')
                    },
                    {
                        name: "Nastya",
                        code: "ru-RU-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s3_Nastya.mp3')
                    },
                    {
                        name: "Olga",
                        code: "ru-RU-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s4_Olga.mp3')
                    },
                    {
                        name: "Tanya",
                        code: "ru-RU-Wavenet-E",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Maria",
                        code: "ru-RU-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Tatyana",
                        code: "Tatyana",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Artem",
                        code: "ru-RU-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s1_Artem.mp3')
                    },
                    {
                        name: "Igor",
                        code: "ru-RU-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s2_Igor.mp3')
                    },
                    {
                        name: "Sergey",
                        code: "ru-RU-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s3_Sergey.mp3')
                    },
                    {
                        name: "Vova",
                        code: "ru-RU-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/ru_ru_s4_Vova.mp3')
                    },
                    {
                        name: "Maxim",
                        code: "Maxim",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Slovak (Slovakia)', code: 'sk-SK',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Dalenka",
                        code: "sk-SK-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/sk_sk_s1_Dalenka.mp3')
                    },
                    {
                        name: "Ladislava",
                        code: "sk-SK-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/sk_sk_s2_Ladislava.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: 'Spanish (Spain)', code: 'es-ES',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Conchita",
                        code: "Conchita",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Lucia",
                        code: "Lucia",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Celesta",
                        code: "es-ES-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/es_es_s1_Celesta.mp3')
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Enrique",
                        code: "Enrique",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Spanish US', code: 'es-US',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Lupe",
                        code: "Lupe",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    },
                    {
                        name: "Lupe",
                        code: "Lupe",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                    ,
                    {
                        name: "Penelope",
                        code: "Penelope",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Miguel",
                        code: "Miguel",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Spanish (Mexican)', code: 'es-MX',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Mia",
                        code: "Mia",
                        vendor: "aws",
                        voiceType: "Neural",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Swedish (Sweden)', code: 'sv-SE',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Scarlet",
                        code: "sv-SE-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/sv_se_s1_Astrid.mp3')
                    },
                    {
                        name: "Caren",
                        code: "sv-SE-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/sv_se_s2_Caren.mp3')
                    },
                    {
                        name: "Astrid",
                        code: "Astrid",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: 'Turkish (Turkey)', code: 'tr-TR',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Aylin",
                        code: "tr-TR-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s1_Aylin.mp3')
                    },
                    {
                        name: "Emel",
                        code: "tr-TR-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s2_Emel.mp3')
                    },
                    {
                        name: "Filiz",
                        code: "tr-TR-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s3_Filiz.mp3')
                    },
                    {
                        name: "Nehir",
                        code: "tr-TR-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s4_Nehir.mp3')
                    },
                    {
                        name: "Reyhan",
                        code: "tr-TR-Wavenet-C",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s5_Reyhan.mp3')
                    },
                    {
                        name: "Zeynep",
                        code: "tr-TR-Wavenet-D",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s6_Zeynep.mp3')
                    },
                    {
                        name: "Filiz",
                        code: "Filiz",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: 'male',
                characters: [
                    {
                        name: "Ahmet",
                        code: "tr-TR-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s1_Ahmet.mp3')
                    },
                    {
                        name: "Ergin",
                        code: "tr-TR-Standard-E",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s2_Ergin.mp3')
                    },
                    {
                        name: "Muhammed",
                        code: "tr-TR-Wavenet-B",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s3_Muhammed.mp3')
                    },
                    {
                        name: "Yusuf",
                        code: "tr-TR-Wavenet-E",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/tr_tr_s4_Yusuf.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: 'Ukrainian (Ukraine)', code: 'uk-UA',
        voices: [
            {
                type: 'female',
                characters: [
                    {
                        name: "Maryska",
                        code: "uk-UA-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: require('../../assets/audio/gallery/uk_ua_s1_Maryska.mp3')
                    },
                    {
                        name: "Veronika",
                        code: "uk-UA-Wavenet-A",
                        vendor: "Google",
                        voiceType: "WaveNet",
                        voiceSample: require('../../assets/audio/gallery/uk_ua_s2_Veronika.mp3')
                    }
                ]
            }
        ]
    },
    {
        language: "Vietnamese (Vietnam)",
        code: "vi-VN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Tam",
                        code: "vi-VN-Wavenet-A",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Tan",
                        code: "vi-VN-Wavenet-C",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Hue",
                        code: "vi-VN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Phuong",
                        code: "vi-VN-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Duc",
                        code: "vi-VN-Wavenet-B",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Sang",
                        code: "vi-VN-Wavenet-D",
                        vendor: "Google",
                        voiceType: "Wavenet",
                        voiceSample: "todo"
                    },
                    {
                        name: "Due",
                        code: "vi-VN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Quyen",
                        code: "vi-VN-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Chinese (Hong Kong)",
        code: "yue-HK",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Cho",
                        code: "yue-HK-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Chan",
                        code: "yue-HK-Standard-C",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Yun",
                        code: "yue-HK-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    },
                    {
                        name: "Yen",
                        code: "yue-HK-Standard-D",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Thai (Thailand)",
        code: "th-TH",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Malee",
                        code: "th-TH-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: []
            }
        ]
    },
    {
        language: "Bengali (India)",
        code: "bn-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Ashwani",
                        code: "bn-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Ashwani",
                        code: "bn-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Gujarati (India)",
        code: "gu-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Ishya",
                        code: "gu-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Kumar",
                        code: "gu-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Kannada (India)",
        code: "kn-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Sheen",
                        code: "kn-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "George",
                        code: "kn-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Malayalam",
        code: "ml-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Tusharika",
                        code: "ml-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Faqid",
                        code: "ml-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Tamil (India)",
        code: "ta-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Vrishti",
                        code: "ta-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Chandresh",
                        code: "ta-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Telugu (India)",
        code: "te-IN",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Hemanta",
                        code: "te-IN-Standard-A",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            },
            {
                type: "male",
                characters: [
                    {
                        name: "Balhaar",
                        code: "te-IN-Standard-B",
                        vendor: "Google",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    },
    {
        language: "Welsh",
        code: "cy-GB",
        voices: [
            {
                type: "female",
                characters: [
                    {
                        name: "Gwyneth",
                        code: "Gwyneth",
                        vendor: "aws",
                        voiceType: "Standard",
                        voiceSample: "todo"
                    }
                ]
            }
        ]
    }
]

export const moduleLanguages = {
    state: state
}
